import { render, staticRenderFns } from "./NextMoveResult.vue?vue&type=template&id=8f9ab2f2&scoped=true"
import script from "./NextMoveResult.vue?vue&type=script&lang=ts"
export * from "./NextMoveResult.vue?vue&type=script&lang=ts"
import style0 from "./NextMoveResult.vue?vue&type=style&index=0&id=8f9ab2f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9ab2f2",
  null
  
)

export default component.exports